import { Accounts } from 'meteor/accounts-base';
import { Meteor } from 'meteor/meteor';
import { Random } from 'meteor/random';

import sendWelcomeEmail from '../../../api/Users/server/send-welcome-email';
import UserSettings from '../../../api/UserSettings/UserSettings';

import getOAuthProfile from '../../../modules/get-oauth-profile';

Accounts.onCreateUser((options, user) => {
  try {
    const userToCreate = user;
    userToCreate._id = Random.id();

    const roles = options.email === 'admin@geomotionvideo.com' ? [] : ['free-user'];
    userToCreate.roles = roles;

    if (options.profile) userToCreate.profile = options.profile;
    userToCreate.deleted = 'no';

    if (!userToCreate.storageCuota) {
      userToCreate.storageCuota = {
        sizeLimit: 0,
        usedStorage: 0
      };
    }

    const OAuthProfile = getOAuthProfile(options.profile, userToCreate);
    if (OAuthProfile) sendWelcomeEmail(userToCreate);
    // Sent for OAuth accounts only here. Sent for password accounts after email verification (https://cleverbeagle.com/pup/v1/accounts/email-verification).

    // Add a default settings array for new sign ups (https://cleverbeagle.com/pup/v1/accounts/settings).
    const settings = UserSettings.find().fetch();
    userToCreate.settings = settings;

    // Use the user ID we generated
    /** @deprecated For the moment. */
    // createExampleItems(userToCreate._id);

    return userToCreate;
  } catch (error) {
    throw new Meteor.Error('500', error.message);
  }
});
